/* export
  - menuIdRouteMappings
  - menuIdNameMappingsFromBundle
*/;

export * from 'sce-core/constants';
// #TODO-LIBRARY constants->menuIdRouteMappings Used in 13 places 13 files in WMS /src/app.. should be re-referenced from library directly

export const META_DATA = {
  REC_TYPE: 'recType',
  DOC_STATUS: 'docStatus',
  SKU_GROUP: 'skuGroup',
  MBOL_KEY: 'mbolKey',
  WAVE_KEY: 'wavekey',
  SO_USER_DEFINED_NINE: 'soUdf09',
  CANCEL_REASON_CODE : 'CancelReasonCode',
  ORDER_QTY: 'orderQty',
  ALLOCATED_QTY: 'allocatedQty',
  PACKED_QTY: 'packedQty',
  ALLOC_STATUS_VALUE: 'allocationStatusValue',
  BOOKING_TIME: 'bookingTime',
  BOOKING_DATE: 'bookingDate',
  FROM_BOOKING_TIME: 'fromBookingTime',
  DURATION: 'duration',
  BOOKING_NO: 'bookingNo',
  BOOKING_END_DATE: 'Booking End Date',
  BOOKING_START_DATE: 'Booking Start Date',
  FACILITY: 'facility',
  FROM_DOOR: 'fromDoor',
  IS_EDITABLE : 'isEditable',
  RECEIPT : 'RECEIPT',
  TABLE_NAME: 'tableName',
  ID: 'id',
  DESCR: 'descr',
  REMARK: 'remark',
  LOC: 'loc',
  LOT: 'lot',
  PALLET_TYPE: 'PalletType',
  FINALIZE_FLAG: 'finalizeFlag',
  PERMISSION: 'permission',
  ADJUSTMENT_KEY: 'adjustmentKey',
  COMMODITY: 'commodity',
  QTY: 'qty',
  USER_DEFINE_01: 'userDefine01',
  PO_KEY: 'poKey',
  PO_LINE_NO: 'poLineNo',
  TYPE: 'type'
};

export const DATE_FORMATS = {
  DATE_ONLY: 'YYYY-MM-DD',
  TIME_ONLY: 'HH:mm',
  FULL_TIMESTAMP: 'HH:mm:ss.SSS',
};

export const FIELD_TYPE = {
  DROPDOWN: 'DROPDOWN',
  EDITABLEDROPDOWN: 'EDITABLEDROPDOWN',
  TEXTFIELD: 'TEXTFIELD'
};

export const CONVERSION_TABLES = [
  'userdetailtd',
  'permissionprofdtltd'
];

export const TABLE_NAME = {
  SHIPMENT_ORDER: 'sotd',
  WAVE_CONTROL_TABLE: 'wavecntrltd',
  ASN : 'asntd',
  POPULATE_UCC : 'populateucctd',
  DOCK_DOOR_TABLE: 'ddbookintd',
  CONSIGNEE_SKU: 'CONSIGNEESKUTD',
  UCC_MAIN: 'uccmaintd',
  SHIPREF_TD: 'shipreftd',
  PICK_TD: 'picktd',
  USER_DETAIL_TD: 'userdetailtd',
  MAINTAIN_MSG_TD: 'maintainmsgtd',
  PURCHASE_ORDER: 'potd',
  PO_DETAIL_TD: 'podetailtd',
  PO_ARCHIVE_TD: 'poarchivetd',
  WAVE_CNTRL_ORDER_TD: 'wavecntrlwaveodrtd'
}

export const STORER_CONFIG_KEYS = {
  WAVE_CNTRL_CUSTOMS_MSG: 'CustomsExportDecl_MBL_XD',
  ASN_CUSTOMS_MSG: 'CustomsImportDecl_ASN_XD',
  TMS_OUT_ORD_HDR: 'TMSOutOrdHDR'
}

export const POPULATE = {
  UCC_ADJUSTMENT: 'UCC_Adjustment',
  BTN_KEY: 'btn_populate_adjustment',
  POPULATE_UCC_TD: 'POPULATEUCCTD',
  UCC_POPULATE_ACTION: 'PopulateAll_UCC_Adjustment'
}

export const ERROR_CODES = {
  'CANCEL_CODE_MISMATCH': 'so_cancel_code_mismatch',
  WAVE_NOT_ALLOCATED: 'wave_not_aloc',
  ALLOCATION_ERROR_MES: 'allocation_error',
};

export const MESSAGES = {
  WAVE_ALLOC_POPOUP_HEADER: 'lbl_pop_alloc_header',
  RECEIVED_QTY: 'lbl_rec_qty',
  CONFIRM_ASN_FINALIZE: 'msg_conf_fin',
  CONFIRM_ASN_CLOSE: 'msg_conf_cls_asn'
};

export const ALLOCATION_STATUS = {
  SCHEDULED: '0',      // Awaiting allocation (Scheduled Job)
  IN_PROGRESS: '1',    // Allocation in progress
  PICKED: 5,         // Allocated/Picked
};

export const SORTING_FROM_BE_TD : string[] = [
  'storersearchtd',
  'transferdetailtd',
  'invqcdetailtd',
  'adjdetailtd'
];

export const HEADER_KEYS = {
  SKIP_INTERCEPTOR: 'X-Skip-Interceptor',
}

export const PTW_SERVICE_URL = {
  PTW_SERVICE_URL: 'https://cdt-fbm-ptw-service.maersk-digital.net/fbmptwservice',
  PTW_AUTHZ_URL_CDT: 'https://cdt-fbm-authz-service.maersk-digital.net',
  PTW_AUTHZ_URL_STAGE: 'https://stage-ew-fbm-authz-service.maersk-digital.net',
  PTW_SERVICE_URL_STAGE: 'https://stage-fbm-ptw-service.maersk-digital.net/fbmptwservice',
  PTW_AUTHZ_URL_PROD: 'https://prod-ew-fbm-authz-service.maersk-digital.net/authservice/admin',
  PTW_SERVICE_URL_PROD: 'https://fbm-ptw-service.maersk-digital.net/fbmptwservice'
}

export const PTW_CLIENT_URL = "https://cdt-fbm-ptw-client.maersk-digital.net/";
export const DEFAULT_STORER = 'defaultStorer';
export const HOME_MENU_ID = 'home';
export const CASE_ID_CONFIG_KEY = 'SCEDontAllowEditPickCASEID';
export const UNALLOCATE_ACTION_EVENT = 'unallocate';

export const SEARCH_KEYS = {
  ALL: '*',
  STORER: 'storerKey',
  STORER_NAME: 'storerName',
  CONSIGNEE_NAME: 'consigneeName',
  CONSIGNEE_KEY: 'consigneeKey',
  FACILITY: 'facility',
  LOC_ID: 'locId',
  SKU: 'sku',
  UCC_NO: 'uccNo',
  RECEIPT_KEY: 'receiptKey',
  LOT: 'lot',
  CASE_ID: 'caseID',
  CASEID_POPUP: 'caseid',
  LOAD_KEY: 'loadKey',
  LOAD: 'load',
}

export const UNDEFINED_VALUE = undefined;
export const UNDEFINED_STRING = 'undefined';
export const YES = 'Y';
export const NO = 'N';

export const FIELD_TYPES = {
  DROPDOWN: 'DROPDOWN',
  EDITABLE_DROPDOWN: 'EDITABLEDROPDOWN',
}

export const SEARCH_OPERATORS = {
  IN: 'in',
  AND: 'AND',
};

export const ROWS_WITH_LOTTABLE_FIELDS = [1, 2];

export const LOTTABLE_FIELDS = [
  'lottable01', 'lottable02', 'lottable03', 'lottable04', 'lottable05',
  'lottable06', 'lottable07', 'lottable08', 'lottable09', 'lottable10',
  'lottable11', 'lottable12', 'lottable13', 'lottable14', 'lottable15'
]

export const POPUP_CONFIG = {
  OVERLAY_WIDTH: 1024,
  OVERLAY_HEIGHT: 520,
}

export const TABLE_STYLE = {
  ROW_COLOR: '#FFFFFF',
  ALT_ROW_COLOR: '#E5E5E5',
  TEXT_COLOR: '#212121',
}

/* Jreport constants */
export const DATA_TO_REMOVE: Array<string> = [
  'ExtendedParmDefault1','ExtendedParmDefault2','ExtendedParmDefault3',
  'ExtendedParmDefault4','ExtendedParmDefault5','ReportTitle',
  'NeedExtendedParm'
];

export const REPORT_TYPES = {
  DOC_REPORT: 'DocReport',
};

export const PRINT_SOURCES = {
  JREPORT_BE: 'JReportBE',
  JREPORT: 'JReport',
  WM_REPORT: 'WMReport',
};

/* Dock Door Booking Constants */
export const DDB_CONSTANTS = {
  INBOUND_TD: 'ddbookintd',
  OUTBOUND_TD: 'ddbooktd',
  SCHEDULE_BY_DAY_TD: 'ddschedulebydaytd',
  SCHEDULE_BY_DOOR_TD: 'ddschedulebydoortd',
  BAY_IN : 'BAYIN',
  BAY_OUT : 'BAYOUT',
  OUTBOUND : 'OUTBOUND',
  INBOUND : 'INBOUND',
  INBOUND_EVENT: 'inboundBook',
  OUTBOUND_EVENT: 'outboundBook',
  BLOCK_EVENT : 'block',
  REFRESH_EVENT: 'refresh'
}

export const POPUP_EVENT_TYPE = {
  HIDE: 'hide',
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/constants.ts